module.exports = __webpack_public_path__ + "static/media/cyuce0001.ba9dbe36.jpg";